/** How a live dataset's version reads in a line: "v3 · 25–26 Oct · 100 traces"; with `matched`, "… · 100 of 2,340 matched". */

import type { DatasetVersion } from "@/features/datasets/types";
import { versionPeriod } from "@/features/datasets/live/version-period";
import { formatCount } from "@/lib/format";

export function versionName(
  v: Pick<DatasetVersion, "version" | "period_start" | "period_end" | "item_count" | "matched_count">,
  matched = false,
) {
  const count = matched ? pickedLine(v.item_count, v.matched_count) : `${formatCount(v.item_count)} traces`;
  return [`v${v.version}`, versionPeriod(v), count].filter(Boolean).join(" · ");
}

/** "100 of 2,340 matched", or "100 traces" when the match count is unknown (older pulls). */
export function pickedLine(picked: number, matched: number | null | undefined): string {
  if (matched == null || matched <= picked) return `${formatCount(picked)} traces`;
  return `${formatCount(picked)} of ${formatCount(matched)} matched`;
}
